import React, { useEffect, useState } from "react";
import { Container, Col, FormGroup, Label } from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loading } from "../../share/loading";
import "../../share/form.css";
import "../../borrowSystem/Admin.css";
import "../../borrowSystem/BorrowForm/TabBorrowComponent.css";
import { FaSistrix } from "react-icons/fa";
// import { AiOutlineFolderOpen } from "react-icons/ai";
import { NumberWithCommas } from "../../share/NumberWithCommas";
// import { format, getDate } from "date-fns";
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";
import { ConsiderSupport } from "./ConsiderSupport";

export function SupportAdminDetailComponent() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [toggleState, setToggleState] = useState(1);
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState([]);
  const [supportDetails, setSupportDetails] = useState([]);
  const [dataRegister, setDataRegister] = useState([]);
  console.log("supportDetails", supportDetails);
  console.log("dataRegister", dataRegister);
  const [supportAnnounceFours, setSupportAnnounceFours] = useState([]);
  const [supportcompanyAddress, setSupportcompanyAddress] = useState([]);
  // console.log("supportCompona", supportcompanyAddress)
  const [supportCoordinates, setSupportCoordinates] = useState([]);
  const [supportlawocDetails, setSupportlawocDetails] = useState([]);
  // console.log("supportlawocDetails", supportlawocDetails);
  const [supportAnnounceDetails, setSupportAnnounceDetails] = useState([]);
  // console.log("supportAnnounceDetails", supportAnnounceDetails)
  const [supportAnnounceSix, setSupportAnnounceSix] = useState({});
  const [supportAnnounceSeven, setSupportAnnounceSeven] = useState({})
  const [supportFile, setSupportFile] = useState([]);
  // const [datasupportDetails, setsupportDetailsData] = useState([]);
  const [innovationCourseData, setinnovationCourseData] = useState([]);
  const [expenseInnovationData, setExpenseInnovationData] = useState([]);
  // console.log("supportFile", supportFile)
  // const user = JSON.parse(localStorage.getItem("userData"));

  const [openCourses, setOpenCourses] = useState([]);
  const [openCourses2, setOpenCourses2] = useState([]);
  // const [openCourses3, setOpenCourses3] = useState([]);

  const [showTrainData, setShowTrainData] = useState(false);
  const [showTrainData2, setShowTrainData2] = useState(false);

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }
  function onClickUrl(url) {
    return () => openInNewTab(url)
  }
  useEffect(() => {
    if (searchParams.get("dataVersion") != 1) {
      getdetailsupport();
    }
  }, [searchParams]);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const toggleShowTrainData = () => {
    setShowTrainData(!showTrainData);
  };
  const toggleShowTrainData2 = () => {
    setShowTrainData2(!showTrainData2);
  };

  function opencourse(id) {
    if (openCourses.includes(id)) {
      setOpenCourses(openCourses.filter((i) => i !== id));
    } else {
      setOpenCourses([...openCourses, id]);
    }
  }
  function opencourse2(id) {
    if (openCourses2.includes(id)) {
      setOpenCourses2(openCourses2.filter((i) => i !== id));
    } else {
      setOpenCourses2([...openCourses2, id]);
    }
  }


  async function getdetailsupport() {
    setLoading(true);
    let postData = new FormData();
    // postData.append("deptId", user.deptId)
    postData.append("supportId", searchParams.get("id"));
    try {
      let res = await fetch("/api/Support/alldetailsupport", {
        method: "POST",
        body: postData,
      });
      // let resJson = await res.json(); 
      // await resJson.dataenum.map((item) =>{
      //   const { supportcompanyAddress , supportlawocDetails , 
      //     supportcurrentAddress, 
      //     supportCoordinates,supportDetails } = item;


      // });
      const data = await res.json();
      // console.log(data.dataenum);
      // setData(data.dataenum);
      setSupportDetails(data.dataenum.supportDetails);
      setDataRegister(data.dataenum.detailTdRegisters);
      // setSupportAddress(data.dataenum.supportcurrentAddress)
      setSupportcompanyAddress(data.dataenum.supportcompanyAddress)
      setSupportCoordinates(data.dataenum.supportCoordinates)
      setSupportlawocDetails(data.dataenum.supportlawocDetails)
      setSupportAnnounceFours(data.dataenum.supportAnnounceFours)
      setSupportAnnounceDetails(data.dataenum.supportAnnounceDetailAllNumbers)
      setSupportAnnounceSix(data.dataenum.supportAnnounceSixs)
      setSupportAnnounceSeven(data.dataenum.supportAnnounceSevens)
      setSupportFile(data.dataenum.supportAnnounceFiles)
      // setsupportDetailsData(data.dataenum.supportInnovationData2);
      setinnovationCourseData(data.dataenum.innovationCourseData2);
      setExpenseInnovationData(data.dataenum.expenseInnovationData2);
      // console.log("dataalldetail", data.dataenum);
    } catch (e) {
      console.log("err =>" + e);
    } finally {
      setLoading(false);
    }
  }

  // const backbutton = () => {
  //   navigate(`/supporting/admin/check?`)
  // }
  // const currentYear = new Date().getFullYear() + 543;

  return (
    <>
      {searchParams.get("dataVersion") != 1 ? (
        <>
          {/* tab */}
          <Container className="d-flex justify-content-center align-items-center mt-2 mb-4 tab-container">
            <div
              className={
                toggleState === 1
                  ? "tab-item tab-item-active text-center"
                  : "tab-item tab-item-non-active text-center"
              }
              // className="tab-item tab-item-active text-center"
              style={{ lineHeight: "3rem", cursor: "pointer" }}
              onClick={() => {
                toggleTab(1);
              }}
            >
              <span className="px-3">ข้อมูลการขอเงินช่วยเหลือหรืออุดหนุน</span>
            </div>

            <div
              className={
                toggleState === 2
                  ? "tab-item tab-item-active text-center "
                  : "tab-item tab-item-non-active text-center"
              }
              style={{ lineHeight: "3rem", cursor: "pointer" }}
              onClick={() => {
                toggleTab(2);
              }}
            >
              <span className="px-3">ข้อมูลเพิ่มเติมและเอกสารประกอบการขอเงินช่วยเหลือหรืออุดหนุน</span>
            </div>

          </Container>

          <Container className="d-flex flex-column justify-content-center align-items-center">
            <div className="form-border">

              {!loading ? (
                <>
                  <div className={toggleState === 1 ? "p-5 mb-4" : "non-active"}>
                    {dataRegister?.map((data, i) => (
                      <div key={i}>

                        {/* <FormGroup>
                      <Label>หน่วยงาน</Label>
                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data.deptName ? data.deptName : "-"}</p>
                    </FormGroup> */}
                        <FormGroup>
                          <Label>ชื่อ (ผู้ขอรับเงิน)</Label>
                          <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data.fullName ? data.fullName : "-"}</p>
                        </FormGroup>

                        <FormGroup>
                          <Label>{data.typeName === "นิติบุคคล" ? "เลขที่ทะเบียนนิติบุคคล 13 หลัก" : "เลขที่บัตรประจำตัวประชาชน 13 หลัก"}</Label>
                          <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data.customerNo}</p>
                        </FormGroup>

                        {data.businessType ? (
                          <FormGroup>
                            <Label>ประกอบกิจการประเภท</Label>
                            <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data.businessType}</p>
                          </FormGroup>
                        ) : null}
                        {data.industrialName ? (
                          <FormGroup>
                            <Label>ประเภทอุตสาหกรรม</Label>
                            <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data.industrialName}</p>
                          </FormGroup>
                        ) : null}
                        {data.email ? (
                          <FormGroup>
                            <Label>อีเมล</Label>
                            <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data.email}</p>
                          </FormGroup>
                        ) : null}

                        {data.typeName === "นิติบุคคล" ? (
                          <>
                            {data.address?.map((address, j) => (
                              <React.Fragment key={j}>
                                <Label>ที่อยู่สถานประกอบการ</Label>
                                <div className="px-4 pt-4">
                                  <FormGroup row>
                                    <Label
                                      for="addNo"
                                      sm={2}
                                    >
                                      เลขที่
                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addNo}</p>
                                    </Col>

                                    <Label
                                      for="moo"
                                      sm={2}
                                    >
                                      หมู่ที่
                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addMo ? address.addMo : "-"}</p>
                                    </Col>
                                  </FormGroup>

                                  <FormGroup row>
                                    <Label
                                      for="soi"
                                      sm={2}
                                    >
                                      ซอย
                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addSoi ? address.addSoi : "-"}</p>
                                    </Col>
                                    <Label
                                      for="street"
                                      sm={2}
                                    >
                                      ถนน
                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addStreet ? address.addStreet : "-"}</p>
                                    </Col>
                                  </FormGroup>

                                  <FormGroup row>
                                    <Label
                                      for="addProvince"
                                      sm={2}
                                    >
                                      จังหวัด

                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addProvince ? address.addProvince : "-"}</p>
                                    </Col>

                                    <Label
                                      for="district_id"
                                      sm={2}
                                    >
                                      อำเภอ/เขต

                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addAmphur ? address.addAmphur : "-"}</p>
                                    </Col>
                                  </FormGroup>

                                  <FormGroup row>
                                    <Label
                                      for="addTumbon"
                                      sm={2}
                                    >
                                      ตำบล/แขวง

                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addTumbon ? address.addTumbon : "-"}</p>
                                    </Col>

                                    <Label
                                      for="postcode"
                                      sm={2}
                                    >
                                      รหัสไปรษณีย์

                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addPostCode ? address.addPostCode : "-"}</p>
                                    </Col>
                                  </FormGroup>
                                </div>
                              </React.Fragment>
                            ))}
                          </>
                        ) : (
                          <>
                            {data.address?.map((address, j) => (
                              <React.Fragment key={j}>
                                <Label>ที่อยู่ตามทะเบียนบ้าน</Label>
                                <div className="px-4 pt-4">
                                  <FormGroup row>
                                    <Label
                                      for="addNo"
                                      sm={2}
                                    >
                                      เลขที่
                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addNo}</p>
                                    </Col>

                                    <Label
                                      for="moo"
                                      sm={2}
                                    >
                                      หมู่ที่
                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addMo ? address.addMo : "-"}</p>
                                    </Col>
                                  </FormGroup>

                                  <FormGroup row>
                                    <Label
                                      for="soi"
                                      sm={2}
                                    >
                                      ซอย
                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addSoi ? address.addSoi : "-"}</p>
                                    </Col>

                                    <Label
                                      for="street"
                                      sm={2}
                                    >
                                      ถนน
                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addStreet ? address.addStreet : "-"}</p>
                                    </Col>
                                  </FormGroup>

                                  <FormGroup row>
                                    <Label
                                      for="addProvince"
                                      sm={2}
                                    >
                                      จังหวัด

                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addProvince ? address.addProvince : "-"}</p>
                                    </Col>

                                    <Label
                                      for="district_id"
                                      sm={2}
                                    >
                                      อำเภอ/เขต

                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addAmphur ? address.addAmphur : "-"}</p>
                                    </Col>
                                  </FormGroup>

                                  <FormGroup row>
                                    <Label
                                      for="addTumbon"
                                      sm={2}
                                    >
                                      ตำบล/แขวง

                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addTumbon ? address.addTumbon : "-"}</p>
                                    </Col>

                                    <Label
                                      for="postcode"
                                      sm={2}
                                    >
                                      รหัสไปรษณีย์

                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addPostCode ? address.addPostCode : "-"}</p>
                                    </Col>
                                  </FormGroup>
                                </div>
                              </React.Fragment>
                            ))}

                            {data.cAddress?.map((address, j) => (
                              <React.Fragment key={j}>
                                <Label>ที่อยู่ปัจจุบัน (ที่ติดต่อได้)</Label>
                                <div className="px-4 pt-4">
                                  <FormGroup row>
                                    <Label
                                      for="addNo"
                                      sm={2}
                                    >
                                      เลขที่
                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addNo}</p>
                                    </Col>

                                    <Label
                                      for="moo"
                                      sm={2}
                                    >
                                      หมู่ที่
                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addMo ? address.addMo : "-"}</p>
                                    </Col>
                                  </FormGroup>

                                  <FormGroup row>
                                    <Label
                                      for="soi"
                                      sm={2}
                                    >
                                      ซอย
                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addSoi ? address.addSoi : "-"}</p>
                                    </Col>

                                    <Label
                                      for="street"
                                      sm={2}
                                    >
                                      ถนน
                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addStreet ? address.addStreet : "-"}</p>
                                    </Col>
                                  </FormGroup>

                                  <FormGroup row>
                                    <Label
                                      for="addProvince"
                                      sm={2}
                                    >
                                      จังหวัด

                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addProvince ? address.addProvince : "-"}</p>
                                    </Col>

                                    <Label
                                      for="district_id"
                                      sm={2}
                                    >
                                      อำเภอ/เขต

                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addAmphur ? address.addAmphur : "-"}</p>
                                    </Col>
                                  </FormGroup>

                                  <FormGroup row>
                                    <Label
                                      for="addTumbon"
                                      sm={2}
                                    >
                                      ตำบล/แขวง

                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addTumbon ? address.addTumbon : "-"}</p>
                                    </Col>

                                    <Label
                                      for="postcode"
                                      sm={2}
                                    >
                                      รหัสไปรษณีย์

                                    </Label>
                                    <Col sm={4}>
                                      <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addPostCode ? address.addPostCode : "-"}</p>
                                    </Col>
                                  </FormGroup>
                                </div>
                              </React.Fragment>
                            ))}
                          </>
                        )}
                      </div>
                    ))}
                    <div >

                      {/* <FormGroup>
                    <Label className="">ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน :</Label>
                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">

                      {supportDetails.supportName ? supportDetails.supportName : "-"}
                    </p>
                  </FormGroup>

                  <FormGroup>
                    <Label className="">เลขที่ทะเบียนนิติบุคคล :</Label>
                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                      {supportDetails.customerNo ? supportDetails.customerNo : "-"}
                    </p>
                  </FormGroup> */}

                      <FormGroup>
                        <Label className="">โดย (ผู้มีอำนาจกระทำการแทน/ผู้รับมอบอำนาจ) :</Label>
                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                          {supportDetails.authoriseName ? supportDetails.authoriseName : "-"}
                        </p>
                      </FormGroup>

                      <FormGroup>
                        <Label className="">เลขที่บัตรประจำตัวประชาชน</Label>
                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                          {supportDetails.personalNo ? supportDetails.personalNo : "-"}
                        </p>
                      </FormGroup>

                      <FormGroup>
                        <Label className="">เช็คขีดคร่อมสั่งจ่ายในนาม</Label>
                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                          {supportDetails.paymentName ? supportDetails.paymentName : "-"}
                        </p>
                      </FormGroup>



                      {supportcompanyAddress.companyAddressNo != null ? (
                        <>
                          <Label className="mt-1">
                            ที่ตั้ง ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน
                          </Label>
                          <FormGroup row className="m-3">
                            <Label
                              for="addNo"
                              sm={2}
                            >
                              เลขที่
                            </Label>
                            <Col sm={4}>
                              <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                {supportcompanyAddress.companyAddressNo ? supportcompanyAddress.companyAddressNo : "-"}
                              </p>

                            </Col>

                            <Label
                              for="moo"
                              sm={2}
                            >
                              หมู่ที่
                            </Label>
                            <Col sm={4}>
                              {supportcompanyAddress.companyMoo == null ? (
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  -
                                </p>
                              ) : (
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {supportcompanyAddress.companyMoo ? supportcompanyAddress.companyMoo : "-"}
                                </p>
                              )}
                            </Col>
                          </FormGroup>

                          <FormGroup row className="m-3">
                            <Label
                              for="soi"
                              sm={2}
                            >
                              ซอย
                            </Label>
                            <Col sm={4}>
                              {supportcompanyAddress.companySoi != null ? (
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {supportcompanyAddress.companySoi ? supportcompanyAddress.companySoi : "-"}
                                </p>
                              ) : (
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  -
                                </p>
                              )}
                            </Col>

                            <Label
                              for="street"
                              sm={2}
                            >
                              ถนน
                            </Label>
                            <Col sm={4}>
                              {supportcompanyAddress.companyStreet != null ? (
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {supportcompanyAddress.companyStreet ? supportcompanyAddress.companyStreet : "-"}
                                </p>
                              ) : (
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  -
                                </p>
                              )}
                            </Col>
                          </FormGroup>

                          <FormGroup row className="m-3">
                            <Label
                              for="province"
                              sm={2}
                            >
                              จังหวัด
                            </Label>
                            <Col sm={4}>
                              {supportcompanyAddress.companyProvinceName != null ? (
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {supportcompanyAddress.companyProvinceName ? supportcompanyAddress.companyProvinceName : "-"}
                                </p>
                              ) : (
                                <p
                                  className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  -
                                </p>
                              )}
                            </Col>


                            <Label
                              for="amphur"
                              sm={2}
                            >
                              อำเภอ/เขต
                            </Label>
                            <Col sm={4}>
                              {supportcompanyAddress.companyAmphurName != null ? (
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {supportcompanyAddress.companyAmphurName ? supportcompanyAddress.companyAmphurName : "-"}
                                </p>
                              ) : null}
                            </Col>
                          </FormGroup>

                          <FormGroup row className="m-3">
                            <Label
                              for="tumbon"
                              sm={2}
                            >
                              ตำบล/แขวง
                            </Label>
                            <Col sm={4}>
                              {supportcompanyAddress.companyTumbonName != null ? (
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {supportcompanyAddress.companyTumbonName ? supportcompanyAddress.companyTumbonName : "-"}
                                </p>
                              ) : null}
                            </Col>

                            <Label
                              for="amphur"
                              sm={2}
                            >
                              รหัสไปรษณีย์
                            </Label>
                            <Col sm={4}>
                              {supportcompanyAddress.companyPostCode != null ? (
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {supportcompanyAddress.companyPostCode ? supportcompanyAddress.companyPostCode : "-"}
                                </p>
                              ) : null}
                            </Col>
                          </FormGroup>



                          <div className="d-flex justify-content-between align-items-center">

                            <FormGroup className="w-75 mx-2">
                              <Label>ประกอบกิจการประเภท</Label>
                              <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                {supportCoordinates.businessType ? supportCoordinates.businessType : "-"}
                              </p>
                            </FormGroup>

                            <FormGroup className="w-25 mx-2">
                              <Label>จำนวนลูกจ้าง</Label>
                              <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                {/* {item.position ? item.position : "-"} - */} -
                              </p>
                            </FormGroup>
                          </div>

                          <FormGroup>
                            <Label className="">ชื่อผู้ประสานงาน</Label>
                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                              {supportCoordinates.coordinateName ? supportCoordinates.coordinateName : "-"}
                            </p>
                          </FormGroup>
                          <div className="d-flex justify-content-between align-items-center">

                            <FormGroup className="w-50 mx-2">
                              <Label>โทรศัพท์</Label>
                              <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                {supportCoordinates.coordinatePhone ? supportCoordinates.coordinatePhone : "-"}
                              </p>
                            </FormGroup>

                            <FormGroup className="w-50 mx-2">
                              <Label>โทรศัพท์มือถือ</Label>
                              <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                {supportCoordinates.coordinateMobile ? supportCoordinates.coordinateMobile : "-"}
                              </p>
                            </FormGroup>
                          </div>
                          <div className="d-flex justify-content-between align-items-center">

                            <FormGroup className="w-50 mx-2">
                              <Label>โทรสาร</Label>
                              <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                {supportCoordinates.coordinateFax ? supportCoordinates.coordinateFax : "-"}
                              </p>
                            </FormGroup>

                            <FormGroup className="w-50  mx-2">
                              <Label>E-mail</Label>
                              <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                {supportCoordinates.coordinateEmail ? supportCoordinates.coordinateEmail : "-"}
                              </p>
                            </FormGroup>
                          </div>


                        </>
                      ) : (<></>)}



                    </div>
                    {/* ))} */}

                    <div className="d-flex align-items-center justify-content-center w-100 mt-3">
                      <button onClick={() => {
                        navigate(
                          `/supporting/admin/Check?req=${searchParams.get(
                            "id"
                          )}`
                        );
                      }} className="btn-blue p-2 w-50">ย้อนกลับ</button>
                    </div>

                  </div>


                  <div className={toggleState === 2 ? "p-5 mb-4" : "non-active"}>

                    <div className="d-flex flex-column justify-content-between align-items-center">
                      <FormGroup className="w-100 mx-2">

                        {supportDetails.supportType === "1" ? (
                          <div>
                            {supportAnnounceFours.map((item, i) => (
                              <div key={i} className="border border-1 mt-3 p-3">

                                <Label className="w-100">
                                  เลขที่ใบอนุญาต เลขที่
                                  <span className="input-color mx-1">
                                    {item.allowCode}
                                  </span>
                                </Label>
                                <Label className="w-100">
                                  วันที่ได้รับใบอนุญาต
                                  <span className="input-color mx-1">
                                    {item.allowDate}
                                  </span>
                                </Label>
                                <Label className="w-100">
                                  สาขาอาชีพ
                                  <span className="input-color mx-1">
                                    {item.lawOccupationName}
                                  </span>
                                </Label>
                                <Label className="w-100">
                                  สาขา
                                  <span className="input-color mx-1">
                                    {item.testOccupationName}
                                  </span>
                                </Label>
                                <Label className="w-100">
                                  จำนวน
                                  <span className="input-color mx-1">
                                    {item.amount}
                                  </span>
                                  คน
                                </Label>
                              </div>
                            ))}



                          </div>

                        ) : (null)}

                        {supportDetails.supportType === "2" ? (
                          <div className="w-100">
                            <Label>ดำเนินการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ ตามที่กรมพัฒนาฝีมือแรงงานส่งผู้เข้ารับการทดสอบ
                              ไปทดสอบในสาขาอาชีพที่จำเป็นต้องให้การส่งเสริมหรือสนับสนุน ตามประกาศข้อ 5
                            </Label>
                            {supportAnnounceDetails.map((item, i) => (

                              <div className="w-100">


                                <FormGroup className="">
                                  <FormGroup>
                                    <Label>สาขาอาชีพ</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.lawOccupationId ? item.lawOccupationId : "-"}
                                    </p>
                                  </FormGroup>
                                  <FormGroup>
                                    <Label>สาขา</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.testOccupationId ? item.testOccupationId : "-"}
                                    </p>
                                  </FormGroup>

                                  <FormGroup>
                                    <Label>จำนวนคน</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.personTotal ? item.personTotal : "-"}
                                    </p>
                                  </FormGroup>

                                  <FormGroup>
                                    <Label>ค่าทดสอบคนละ</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.testExpense ? item.testExpense : "-"}
                                    </p>

                                  </FormGroup>
                                  <FormGroup>
                                    <Label className="ms-2">รวมเป็นจำนวนเงิน</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {NumberWithCommas(item.personTotal * item.testExpense)}
                                    </p>
                                  </FormGroup>






                                </FormGroup>


                                <div>

                                </div>

                              </div>
                            ))}



                          </div>



                        ) : (null)}

                        {supportDetails.supportType === "3" ? ( // ไม่รู้ว่าใช้ข้อมูลคอลั่มไหน
                          <>
                            {supportAnnounceDetails.map((item, i) => (

                              <div className="w-100">
                                <p className="input-color">รายการที่ {i + 1}</p>

                                <FormGroup className="px-3">
                                  <div className="d-flex">
                                    <FormGroup className="w-50">
                                      <Label>ใบเสร็จรับเงินเล่มที่</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.reciept ? item.reciept : "-"}
                                      </p>
                                    </FormGroup>
                                    <FormGroup className="w-50">
                                      <Label>เลขที่ใบเสร็จรับเงิน</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.recieptNo ? item.recieptNo : "-"}
                                      </p>
                                    </FormGroup>
                                  </div>
                                  <div className="d-flex">
                                    <FormGroup className="w-50">
                                      <Label>วันที่ในใบเสร็จรับเงิน</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.recieptDate ? item.recieptDate : "-"}
                                      </p>
                                    </FormGroup>
                                    <FormGroup className="w-50">
                                      <Label>เป็นจำนวนเงิน</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.amountTotal ? NumberWithCommas(item.amountTotal) : "-"}
                                      </p>
                                    </FormGroup>
                                  </div>


                                  <FormGroup>
                                    <Label>สาขาอาชีพ</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.lawOccupationId ? item.lawOccupationId : "-"}
                                    </p>
                                  </FormGroup>
                                  <FormGroup>
                                    <Label>สาขา</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.testOccupationId ? item.testOccupationId : "-"}
                                    </p>
                                  </FormGroup>

                                  <FormGroup>
                                    <Label>จำนวนคน</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.personTotal ? item.personTotal : "-"}
                                    </p>
                                  </FormGroup>
                                </FormGroup>

                                <div>

                                </div>

                              </div>
                            ))}



                          </>


                        ) : (null)}

                        {supportDetails.supportType === "4" ? (// ไม่รู้ว่าใช้ข้อมูลคอลั่มไหน
                          // supportAnnounceSix
                          <FormGroup>
                            <div>
                              <p className="type-register">นำส่งเงินสมทบกองทุนพัฒนาฝีมือแรงงาน ประจำปี พ.ศ. {supportAnnounceSix.year2} วันที่นำส่งเงิน {supportAnnounceSix.receiptDate}</p>
                              <p className="type-register">เป็นจำนวนเงิน<span className="mx-1">{NumberWithCommas(supportAnnounceSix.amount)}</span>บาท</p>
                            </div>
                            <p className="type-register">ในปี พ.ศ. {supportAnnounceSix.year1} (ปีถัดมา) มีลูกจ้างเฉลี่ยรวมทั้งสิ้น จำนวน <span className="mx-1">{NumberWithCommas(supportAnnounceSix.avgMan)}</span> คน ร้อยละ {supportAnnounceSix.perc}  จำนวน <span className="mx-1">{supportAnnounceSix.lawTrainMan}</span> คน</p>
                            <p className="type-register">ได้ดำเนินการพัฒนาฝีมือแรงงานให้แก่ลูกจ้างครบตามสัดส่วนที่กฎหมายกำหนด รวมจำนวน <span className="mx-1">{supportAnnounceSix.spkTrainMan} คน </span>ดังนี้ </p>
                            <div className="px-1">
                              <ul>
                                <li>
                                  <div className="d-flex justify-content-start">
                                    <span className="type-register">จัดให้มีการฝึกอบรมฝีมือแรงงาน จำนวน</span>
                                    <span className="type-register mx-1">{supportAnnounceSix.train ? supportAnnounceSix.train : "-"} คน</span>
                                  </div>

                                </li>
                                <li>
                                  <div className="d-flex justify-content-start">
                                    <span className="type-register">ผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ จำนวน</span>
                                    <span className="type-register mx-1">{supportAnnounceSix.test ? supportAnnounceSix.test : "-"} คน</span>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex justify-content-start">
                                    <span className="type-register">ผ่านการรับรองความรู้ความสามารถ จำนวน</span>
                                    <span className="type-register mx-1">{supportAnnounceSix.oloc ? supportAnnounceSix.oloc : "-"} คน</span>
                                  </div>

                                </li>
                              </ul>
                            </div>

                          </FormGroup>
                        ) : (null)}

                        {supportDetails.supportType === "5" ? (
                          <FormGroup>
                            <p className="type-register">ในปี พ.ศ. {supportAnnounceSeven.recieveYear} (ปีที่ผ่านมา) มีลูกจ้างเฉลี่ยรวมทั้งสิ้น จำนวน <span className="mx-1">{supportAnnounceSeven.avgMan}</span> คน ร้อยละ 70 จำนวน <span className="mx-1">{supportAnnounceSeven.avg70}</span> คน</p>
                            <p className="type-register">ได้ดำเนินการพัฒนาฝีมือแรงงานให้แก่ลูกจ้าง จำนวน  <span className="mx-1">{supportAnnounceSeven.spkTrainMan} คน</span> คิดเป็นร้อยละ <span className="mx-1">{supportAnnounceSeven.percent}</span> ของลูกจ้างทั้งหมด (ไม่ซ้ำคน) ดังนี้ </p>
                            <div className="px-1">
                              <ul>
                                <li>
                                  <div className="d-flex justify-content-start">
                                    <span className="type-register">จัดให้มีการฝึกอบรมฝีมือแรงงาน จำนวน</span>
                                    <span className="type-register mx-1">{supportAnnounceSeven.train ? supportAnnounceSeven.train : "-"} คน</span>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex justify-content-start">
                                    <span className="type-register">ผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ จำนวน</span>
                                    <span className="type-register mx-1">{supportAnnounceSeven.test ? supportAnnounceSeven.test : "-"} คน</span>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex justify-content-start">
                                    <span className="type-register">ผ่านการรับรองความรู้ความสามารถ จำนวน</span>
                                    <span className="type-register mx-1">{supportAnnounceSeven.oloc ? supportAnnounceSeven.oloc : "-"} คน</span>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <p className="type-register">ในส่วนที่เกินกว่าร้อยละ 70 ของลูกจ้างทั้งหมด คิดเป็นจำนวน {supportAnnounceSeven.more70} คน มีสิทธิขอรับช่วยเหลือหรืออุดหนุน คนละ 200 บาท จำนวนเงินรวม {NumberWithCommas(Number(supportDetails.amount))} บาท</p>

                          </FormGroup>



                        ) : (null)}

                        {supportDetails.supportType === "6" ? (
                          <>
                            <>
                              {supportAnnounceDetails.map((item, i) => (

                                <div className="w-100">
                                  <p className="input-color">รายการที่ {i + 1}</p>

                                  <FormGroup className="px-3">
                                    <FormGroup>
                                      <Label>สาขาอาชีพ</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.lawOccupationId ? item.lawOccupationId : "-"}
                                      </p>
                                    </FormGroup>
                                    <FormGroup>
                                      <Label>สาขา</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.testOccupationId ? item.testOccupationId : "-"}
                                      </p>
                                    </FormGroup>
                                    <div className="d-flex">
                                      <FormGroup className="w-50">
                                        <Label>ระดับ</Label>
                                        <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                          {item.testOccupationLevel ? item.testOccupationLevel : "-"}
                                        </p>
                                      </FormGroup>

                                      <FormGroup className="w-50">
                                        <Label>จำนวนคน</Label>
                                        <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                          {item.personTotal ? item.personTotal : "-"}
                                        </p>
                                      </FormGroup>
                                    </div>
                                  </FormGroup>
                                  <div>
                                  </div>
                                </div>
                              ))}
                            </>
                          </>

                        ) : (null)}

                        {supportDetails.supportType === "7" ? (
                          <>
                            {supportAnnounceDetails.map((item, i) => (

                              <div className="w-100">
                                <p className="input-color">รายการที่ {i + 1}</p>

                                <FormGroup className="px-3">
                                  <FormGroup>
                                    <Label>ชื่อ-สกุล</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.titleId ? item.titleId : "-"} <span className="mx-1">{item.employeeFullName ? item.employeeFullName : "-"}</span>
                                    </p>
                                  </FormGroup>
                                  <FormGroup>
                                    <Label>สาขาอาชีพ</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.lawOccupationId ? item.lawOccupationId : "-"}
                                    </p>
                                  </FormGroup>
                                  <FormGroup>
                                    <Label>สาขา</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.testOccupationId ? item.testOccupationId : "-"}
                                    </p>
                                  </FormGroup>
                                  <div className="d-flex">
                                    <FormGroup className="w-50">
                                      <Label>ระดับ</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.testOccupationLevel ? item.testOccupationLevel : "-"}
                                      </p>
                                    </FormGroup>

                                    <FormGroup className="w-50">
                                      <Label>จำนวนเงิน (บาท)</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.payRateAmount ? NumberWithCommas(item.payRateAmount) : "-"}
                                      </p>
                                    </FormGroup>

                                  </div>
                                  <div className="d-flex">
                                    <FormGroup className="w-50">
                                      <Label>วันที่เริ่มจ่ายงวดแรก</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.payRateStartDate ? item.payRateStartDate : "-"}
                                      </p>
                                    </FormGroup>

                                    <FormGroup className="w-50">
                                      <Label>วันที่เริ่มจ่ายงวดสุดท้าย</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.payRateEndDate ? item.payRateEndDate : "-"}
                                      </p>
                                    </FormGroup>
                                    <FormGroup className="w-50">
                                      <Label>วันที่ออกหนังสือรับรอง</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.certificateDate ? item.certificateDate : "-"}
                                      </p>
                                    </FormGroup>

                                  </div>


                                </FormGroup>






                              </div>
                            ))}


                          </>

                        ) : (null)}

                        {/* //ประกาศ 10 */}
                        {/* {supportDetails.supportType === "8" ? (

                      <div className="w-100">
                        {supportlawocDetails.map((item, i) => (
                          <div className="w-100">
                            <Label>ดำเนินการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ
                              และส่งเงินค่าทดสอบเข้ากองทุนพัฒนาฝีมือแรงงานตามมาตรา 27 วรรคสอง (3/1) ตามประกาศข้อ 11</Label>

                            <div className="d-flex align-items-center">
                              <Label>เป็นจำนวนเงิน</Label>
                              <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                {item.allamount ? item.allamount : "-"}
                              </p>
                              <Label className="ms-2">บาท</Label>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                              <Label>ตามใบเสร็จรับเงิน เล่มที่</Label>
                              <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                {item.recipt ? item.recipt : "-"}
                              </p>
                              <Label className="ms-2">เลขที่</Label>
                              <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                {item.reciptNo ? item.reciptNo : "-"}
                              </p>
                              <Label className="ms-2">ลงวันที่</Label>
                              <p className="ms-2 p-1 border rounded-pill w-25 text-center">

                                {item.reciptDate ? item.reciptDate : "-"}

                              </p>
                            </div>

                            <div className="border rounded border-primary shadow p-3 mb-5 mt-3">
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <Label>สาขาอาชีพ</Label>
                                <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                  {item.lawocpationName ? item.lawocpationName : "-"}
                                </p>
                                <Label className="ms-2">สาขา</Label>
                                <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                  {item.testocpationName ? item.testocpationName : "-"}
                                </p>
                                <Label className="ms-2">จำนวน</Label>
                                <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                  {item.personTotal ? item.personTotal : "-"}
                                </p>
                                <Label className="ms-2">คน</Label>
                              </div>
                              <div className="d-flex align-items-center">
                                <Label className="ms-2">กำหนดค่าทดสอบคนละ</Label>
                                <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                  {NumberWithCommas(item.testExpense ? item.testExpense : "-")}
                                </p>
                                <Label className="ms-2">รวมเป็นจำนวนเงิน</Label>
                                <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                  {NumberWithCommas(item.amountTotal ? item.amountTotal : "-")}
                                </p>
                                <Label className="ms-2">บาท</Label>
                              </div>
                            </div>

                            <div>

                            </div>

                          </div>
                        ))}



                      </div>
                    ) : (null)} */}


                        {supportDetails.supportType === "8" ? (

                          <div className="w-100">

                            {innovationCourseData.length ? (
                              <>
                                <div>
                                  <p
                                    className="w-100 text-white text-center rounded-pill "
                                    style={{
                                      backgroundColor: "#0A66C2",
                                      lineHeight: "3rem",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      toggleShowTrainData();
                                    }}
                                  >
                                    การขอรับอุดหนุนเพื่อดำเนินการทดสอบ
                                  </p>

                                  {innovationCourseData.map((trainItem, index) => (
                                    <div
                                      key={index}
                                      className={showTrainData !== true ? "non-active" : ""}
                                    >
                                      <p
                                        className="customer-type w-50  text-center border border-primary rounded-pill"
                                        style={{
                                          lineHeight: "2.5rem",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => opencourse(index)}
                                      >
                                        {trainItem.innovationCourseName
                                          ? trainItem.innovationCourseName
                                          : trainItem?.innovationName}
                                      </p>
                                      <div
                                        className={
                                          !openCourses.includes(index) ? "non-active" : ""
                                        }
                                      >
                                        <FormGroup>
                                          <Label className="">
                                            ชื่อหลักสูตรฝึกอบรมเพื่อสร้างสรรค์นวัตกรรม
                                          </Label>
                                          <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                            {trainItem.innovationCourseName
                                              ? trainItem.innovationCourseName
                                              : trainItem?.innovationName}
                                          </p>
                                        </FormGroup>
                                        <Label className="">
                                          รายละเอียดเกี่ยวกับการฝึกอบรม
                                        </Label>
                                        <FormGroup>
                                          <Label className="">ชื่อหลักสูตร</Label>
                                          <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                            {trainItem?.innovationCourseName
                                              ? trainItem?.innovationCourseName
                                              : "-"}
                                          </p>
                                          <Label className="">รุ่นที่</Label>
                                          <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                            {trainItem?.class ? trainItem?.class : "-"}
                                          </p>
                                          <Label className="">ผู้เข้ารับการฝึกอบรม</Label>
                                          <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                            {trainItem?.personTotal
                                              ? trainItem?.personTotal
                                              : "-"}
                                          </p>
                                          <Label className="">ระยะเวลาในการฝึกอบรม</Label>
                                          <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                            {trainItem?.hour ? trainItem?.hour : "-"}
                                          </p>
                                        </FormGroup>

                                        <FormGroup row className="m-3">
                                          <Label for="tumbon" sm={2}>
                                            วันที่
                                          </Label>
                                          <Col sm={4}>
                                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                              {trainItem?.startDate
                                                ? trainItem?.startDate
                                                : "-"}
                                            </p>
                                          </Col>

                                          <Label for="amphur" sm={2}>
                                            ถึงวันที่
                                          </Label>
                                          <Col sm={4}>
                                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                              {trainItem?.endDate
                                                ? trainItem?.endDate
                                                : "-"}
                                            </p>
                                          </Col>
                                        </FormGroup>

                                        <FormGroup>
                                          <Label className="">จำนวนคน</Label>
                                          <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                            {trainItem.personTotal
                                              ? trainItem.personTotal
                                              : "-"}
                                          </p>
                                        </FormGroup>

                                        <Label className="">ชื่อสถานที่ฝึกอบรม</Label>
                                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                          {trainItem.locationName
                                            ? trainItem.locationName
                                            : "-"}
                                        </p>

                                        <FormGroup row className="m-3">
                                          <Label for="addNo" sm={2}>
                                            เลขที่
                                          </Label>
                                          <Col sm={4}>
                                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                              {trainItem.addressNo
                                                ? trainItem.addressNo
                                                : "-"}
                                            </p>
                                          </Col>

                                          <Label for="moo" sm={2}>
                                            หมู่ที่
                                          </Label>
                                          <Col sm={4}>
                                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                              {trainItem.moo ? trainItem.moo : "-"}
                                            </p>
                                          </Col>
                                        </FormGroup>

                                        <FormGroup row className="m-3">
                                          <Label for="soi" sm={2}>
                                            ซอย
                                          </Label>
                                          <Col sm={4}>
                                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                              {trainItem.soi ? trainItem.soi : "-"}
                                            </p>
                                          </Col>

                                          <Label for="street" sm={2}>
                                            ถนน
                                          </Label>
                                          <Col sm={4}>
                                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                              {trainItem.street ? trainItem.street : "-"}
                                            </p>
                                          </Col>
                                        </FormGroup>

                                        <FormGroup row className="m-3">
                                          <Label for="province" sm={2}>
                                            จังหวัด
                                          </Label>
                                          <Col sm={4}>
                                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                              {trainItem.provinc ? trainItem.provinc : "-"}
                                            </p>
                                          </Col>

                                          <Label for="amphur" sm={2}>
                                            อำเภอ/เขต
                                          </Label>
                                          <Col sm={4}>
                                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                              {trainItem.amphur ? trainItem.amphur : "-"}
                                            </p>
                                          </Col>
                                        </FormGroup>

                                        <FormGroup row className="m-3">
                                          <Label for="tumbon" sm={2}>
                                            ตำบล/แขวง
                                          </Label>
                                          <Col sm={4}>
                                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                              {trainItem.tumbon ? trainItem.tumbon : "-"}
                                            </p>
                                          </Col>

                                          <Label for="amphur" sm={2}>
                                            รหัสไปรษณีย์
                                          </Label>
                                          <Col sm={4}>
                                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                              {trainItem.postcode
                                                ? trainItem.postcode
                                                : "-"}
                                            </p>
                                          </Col>
                                        </FormGroup>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </>
                            ) : null}


                            {expenseInnovationData.length ? (
                              <>
                                <div>
                                  <p
                                    className="w-100 text-white text-center rounded-pill "
                                    style={{
                                      backgroundColor: "#0A66C2",
                                      lineHeight: "3rem",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      toggleShowTrainData2();
                                    }}
                                  >
                                    รายละเอียดค่าใช้จ่าย
                                  </p>
                                  {expenseInnovationData.map((trainItem, index) => (
                                    <div key={index} className={showTrainData2 !== true ? "non-active" : ""}>
                                      <p
                                        className="customer-type w-50  text-center border border-primary rounded-pill"
                                        style={{
                                          lineHeight: "2.5rem",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => opencourse2(index)}
                                      >

                                        {innovationCourseData[0]?.innovationCourseName
                                          ? innovationCourseData[0]?.innovationCourseName
                                          : innovationCourseData[0]?.innovationName}
                                      </p>
                                      <div
                                        className={
                                          !openCourses2.includes(index) ? "non-active" : ""
                                        }
                                      >
                                        {trainItem.inoutTypeId == "1" ? (
                                          <>
                                            <Label className="">
                                              ดำเนินการฝึกเอง (Inhouse Training)
                                            </Label>
                                            <FormGroup className="mt-3">
                                              <Label className="">ค่าตอบแทนวิทยากร</Label>
                                            </FormGroup>
                                            <FormGroup className="mt-3">
                                              <Label className="mt-3">จำนวนชั่วโมง</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {trainItem.tutorHourAmount ? trainItem.tutorHourAmount : "-"} ชั่วโมง

                                              </p>
                                              <Label className="">ชั่วโมงละ</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2(trainItem.tutorRate) ? NumberWithCommmas2(trainItem.tutorRate) : "-"} บาท

                                              </p>
                                              <Label className="">จำนวนเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2((trainItem.tutorHourAmount) * (trainItem.tutorRate)) ? NumberWithCommmas2((trainItem.tutorHourAmount) * (trainItem.tutorRate)) : "-"} บาท
                                              </p>
                                            </FormGroup>

                                            <Label className="mt-3">ค่าวัสดุต่างๆ</Label>
                                            <FormGroup className="mt-3">
                                              <Label className="">จำนวนเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2(trainItem.materialAmount) ? NumberWithCommmas2(trainItem.materialAmount) : "-"} บาท
                                              </p>

                                              <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2(((trainItem.materialAmount)) / (trainItem.materialPersonAmount)) ? NumberWithCommmas2(((trainItem.materialAmount)) / (trainItem.materialPersonAmount)) : "-"} บาท

                                                {/* {NumberWithCommmas2(trainItem.materialPersonAmount) ? (NumberWithCommmas2(Number(trainItem.materialAmount)) / NumberWithCommmas2(Number(trainItem.materialPersonAmount))) : "-"} บาท */}
                                              </p>
                                            </FormGroup>
                                            <Label className="mt-3">รวมค่าใช้จ่ายในการฝึกอบรม</Label>
                                            <FormGroup className="mt-3">
                                              <Label className="">จำนวนเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2(((trainItem.tutorHourAmount) * (trainItem.tutorRate)) + (trainItem.materialAmount)) ? NumberWithCommmas2(((trainItem.tutorHourAmount) * (trainItem.tutorRate)) + (trainItem.materialAmount)) : "-"} บาท
                                              </p>
                                              <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2((((trainItem.tutorHourAmount) * (trainItem.tutorRate)) + (trainItem.materialAmount)) / (trainItem.materialPersonAmount)) ? NumberWithCommmas2((((trainItem.tutorHourAmount) * (trainItem.tutorRate)) + (trainItem.materialAmount)) / (trainItem.materialPersonAmount)) : "-"} บาท

                                              </p>
                                            </FormGroup>
                                          </>
                                        ) : null}

                                        {trainItem.inoutTypeId == "2" ? (
                                          <>
                                            <Label className="">
                                              ส่งไปฝึกอบรมภายนอก (Public Training)
                                            </Label>
                                            <FormGroup className="mt-3">
                                              <Label className="">ค่าตอบแทนวิทยากร</Label>
                                            </FormGroup>
                                            <FormGroup className="mt-3">
                                              <Label className="mt-3">จำนวนชั่วโมง</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {trainItem.tutorHourAmount ? trainItem.tutorHourAmount : "-"} ชั่วโมง

                                              </p>
                                              <Label className="">ชั่วโมงละ</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2(trainItem.tutorRate) ? NumberWithCommmas2(trainItem.tutorRate) : "-"} บาท

                                              </p>
                                              <Label className="">จำนวนเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2((trainItem.tutorHourAmount) * (trainItem.tutorRate)) ? NumberWithCommmas2((trainItem.tutorHourAmount) * (trainItem.tutorRate)) : "-"} บาท
                                              </p>
                                            </FormGroup>

                                            <Label className="mt-3">ค่าวัสดุต่างๆ</Label>
                                            <FormGroup className="mt-3">
                                              <Label className="">จำนวนเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2(trainItem.materialAmount) ? NumberWithCommmas2(trainItem.materialPersonAmount) : "-"} บาท
                                              </p>

                                              <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2(trainItem.materialPersonAmount) ? NumberWithCommmas2(trainItem.materialPersonAmount) : "-"} บาท
                                              </p>
                                            </FormGroup>
                                            <Label className="mt-3">รวมค่าใช้จ่ายในการฝึกอบรม</Label>
                                            <FormGroup className="mt-3">
                                              <Label className="">จำนวนเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2((trainItem.tutorHourAmount) + (trainItem.materialAmount)) ? NumberWithCommmas2((trainItem.tutorHourAmount) + (trainItem.materialAmount)) : "-"} บาท
                                              </p>
                                              <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2(((trainItem.tutorHourAmount) + (trainItem.materialAmount)) / (trainItem.personTotal)) ? NumberWithCommmas2(((trainItem.tutorHourAmount) + (trainItem.materialAmount)) / (trainItem.personTotal)) : "-"} บาท

                                              </p>
                                            </FormGroup>
                                          </>
                                        ) : null}

                                        {trainItem.inoutTypeId == "3" ? (
                                          <>
                                            <Label className="">
                                              ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน
                                            </Label>
                                            <FormGroup className="mt-3">
                                              <Label className="">จำนวนคน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {trainItem.personAmount ? trainItem.personAmount : "-"} คน
                                              </p>
                                              <Label className="">จำนวนเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2(trainItem.amount) ? NumberWithCommmas2(trainItem.amount) : "-"} บาท
                                              </p>

                                            </FormGroup>
                                            <Label className="mt-3">รวมค่าใช้จ่ายในการทดสอบ</Label>
                                            <FormGroup className="mt-3">
                                              <Label className="">จำนวนเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2((trainItem.amount)) ? NumberWithCommmas2((trainItem.personAmount)) : "-"} บาท
                                              </p>
                                              <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2((trainItem.amount) / (trainItem.personAmount)) ? NumberWithCommmas2((trainItem.amount) / (trainItem.personAmount)) : "-"} บาท

                                              </p>
                                            </FormGroup>
                                          </>
                                        ) : null}

                                        {trainItem.inoutTypeId == "4" ? (
                                          <>
                                            <Label className="">
                                              ส่งลูกจ้างเข้ารับการทดสอบมาตรฐานฝีมือแรงงาน
                                            </Label>
                                            <FormGroup className="mt-3">
                                              <Label className="">จำนวนคน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {trainItem.personAmount ? trainItem.personAmount : "-"} คน
                                              </p>
                                              <Label className="">จำนวนเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2(trainItem.amount) ? NumberWithCommmas2(trainItem.amount) : "-"} บาท
                                              </p>

                                            </FormGroup>
                                            <Label className="mt-3">รวมค่าใช้จ่ายในการทดสอบ</Label>
                                            <FormGroup className="mt-3">
                                              <Label className="">จำนวนเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2((trainItem.amount)) ? NumberWithCommmas2((trainItem.personAmount)) : "-"} บาท
                                              </p>
                                              <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                {NumberWithCommmas2((trainItem.amount) / (trainItem.personAmount)) ? NumberWithCommmas2((trainItem.amount) / (trainItem.personAmount)) : "-"} บาท

                                              </p>
                                            </FormGroup>
                                          </>
                                        ) : null}
                                      </div>

                                      <Label className="mt-3">
                                        รวมค่าใช้จ่ายในการฝึกอบรมทั้งหมด
                                      </Label>
                                      <FormGroup className="mt-3">
                                        <Label className="">จำนวนเงิน</Label>
                                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                          {NumberWithCommmas2(trainItem.allAmount) ? NumberWithCommmas2(trainItem.allAmount) : "-"} บาท
                                        </p>
                                        <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                          {NumberWithCommmas2((trainItem.allAmount) / (trainItem.personTotal)) ? NumberWithCommmas2((trainItem.allAmount) / (trainItem.personTotal)) : "-"} บาท


                                        </p>
                                      </FormGroup>

                                    </div>
                                  ))}




                                </div>

                              </>
                            ) : null}



                          </div>
                        ) : (null)}


                        {/* ประกาศ 11 */}
                        {supportDetails.supportType === "9" ? (

                          <>
                            {supportlawocDetails.map((item, i) => (

                              <div className="w-100">
                                <p className="input-color">รายการที่ {i + 1}</p>

                                <FormGroup className="px-3">
                                  <div className="d-flex">
                                    <FormGroup className="w-50">
                                      <Label>ใบเสร็จรับเงินเล่มที่</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.recipt ? item.recipt : "-"}
                                      </p>
                                    </FormGroup>
                                    <FormGroup className="w-50">
                                      <Label>เลขที่ใบเสร็จรับเงิน</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.reciptNo ? item.reciptNo : "-"}
                                      </p>
                                    </FormGroup>
                                  </div>
                                  <div className="d-flex">
                                    <FormGroup className="w-50">
                                      <Label>วันที่ในใบเสร็จรับเงิน</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.reciptDate ? item.reciptDate : "-"}
                                      </p>
                                    </FormGroup>
                                    <FormGroup className="w-50">
                                      <Label>เป็นจำนวนเงิน</Label>
                                      <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                        {item.amountTotal ? NumberWithCommas(item.amountTotal) : "-"}
                                      </p>
                                    </FormGroup>
                                  </div>


                                  <FormGroup>
                                    <Label>สาขาอาชีพ</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.lawocpationName ? item.lawocpationName : "-"}
                                    </p>
                                  </FormGroup>
                                  <FormGroup>
                                    <Label>สาขา</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.testocpationName ? item.testocpationName : "-"}
                                    </p>
                                  </FormGroup>

                                  <FormGroup>
                                    <Label>จำนวนคน</Label>
                                    <p className="ms-2 p-1 border rounded-pill text-center input-color">
                                      {item.personTotal ? item.personTotal : "-"}
                                    </p>
                                  </FormGroup>




                                </FormGroup>


                                {/* <div className="border rounded border-primary shadow p-3 mb-5 mt-3">
                                <div className="d-flex align-items-center justify-content-between w-100">
                                  <Label>สาขาอาชีพ</Label>
                                  <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                    {item.lawocpationName ? item.lawocpationName : "-"}
                                  </p>
                                  <Label className="ms-2">สาขา</Label>
                                  <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                    {item.testocpationName ? item.testocpationName : "-"}
                                  </p>
                                  <Label className="ms-2">จำนวน</Label>
                                  <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                    {item.personTotal ? item.personTotal : "-"}
                                  </p>
                                  <Label className="ms-2">คน</Label>
                                </div>
                                <div className="d-flex align-items-center">
                                  <Label className="ms-2">กำหนดค่าทดสอบคนละ</Label>
                                  <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                    {NumberWithCommas(item.testExpense ? item.testExpense : "-")}
                                  </p>
                                  <Label className="ms-2">รวมเป็นจำนวนเงิน</Label>
                                  <p className="ms-2 p-1 border rounded-pill w-25 text-center">
                                    {NumberWithCommas(item.amountTotal ? item.amountTotal : "-")}
                                  </p>
                                  <Label className="ms-2">บาท</Label>
                                </div>
                              </div> */}

                                <div>

                                </div>

                              </div>
                            ))}



                          </>
                        ) : (null)}
                      </FormGroup>

                      <div className="border border-1 w-100">
                        {supportFile != null ? (
                          <>
                            <p className="text-center text-white" style={{ lineHeight: "3rem", backgroundColor: "#0A66C2" }}>ข้อมูลเพิ่มเติมและเอกสารประกอบการยื่น</p>
                            <div className="d-flex flex-column">

                              {/* {supportFile.fAuthrisePath != null ? (
                            <FormGroup className='d-flex justify-content-between'>
                              <Label className="px-3">หนังสือมอบอำนาจ</Label>
                              <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${supportFile.fAuthrisePath}`)} />
                            </FormGroup>
                          ) : null}
                          {supportFile.fAuthriseIdCardPath != null ? (
                            <FormGroup className='d-flex justify-content-between'>
                              <Label className="px-3">สำเนาบัตรประชาชน ผู้มอบอำนาจ</Label>
                              <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${supportFile.fAuthriseIdCardPath}`)} />
                            </FormGroup>
                          ) : null} */}
                              {supportFile.fIdCardPath != null ? (
                                <FormGroup className='d-flex justify-content-between'>
                                  <Label className="px-3">บัตรประจำตัวประชาชน</Label>
                                  <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${supportFile.fIdCardPath}`)} />
                                </FormGroup>
                              ) : null}
                              {supportFile.fOtherPath != null ? (
                                <FormGroup className='d-flex justify-content-between'>
                                  <Label className="px-3">เอกสารอื่นๆ</Label>
                                  <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${supportFile.fOtherPath}`)} />
                                </FormGroup>
                              ) : null}
                              {supportFile.fCertificatePath != null ? (
                                <FormGroup className='d-flex justify-content-between'>
                                  <Label className="px-3">หนังสือรับรองมาตรฐานฝีมือแรงงาน</Label>
                                  <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${supportFile.fCertificatePath}`)} />
                                </FormGroup>
                              ) : null}

                              {supportFile.fSsoPath != null ? (
                                <FormGroup className='d-flex justify-content-between'>
                                  <Label className="px-3">หนังสือรายการส่งเงินสบทบทุน</Label>
                                  <FaSistrix className="mx-3 style-icon" onClick={onClickUrl(`${supportFile.fSsoPath}`)} />
                                </FormGroup>
                              ) : null}
                            </div>
                          </>
                        ) : (
                          <>
                            <p className="text-center text-white" style={{ lineHeight: "3rem", backgroundColor: "#0A66C2" }}>ข้อมูลเพิ่มเติมและเอกสารประกอบการยื่น</p>
                            <div className="d-flex flex-column align-items-center justify-content-center p-2">
                              ไม่มีเอกสารประกอบการยื่นเพิ่มเติม
                            </div>

                          </>
                        )}



                      </div>




                    </div>

                    <div className="d-flex align-items-center justify-content-center w-100 mt-3">
                      <button onClick={() => {
                        navigate(
                          `/supporting/admin/Check?req=${searchParams.get(
                            "id"
                          )}`
                        );
                      }} className="btn-blue p-2 w-50">ย้อนกลับ</button>
                    </div>

                  </div>
                </>
              ) : (
                <Loading />
              )}
            </div>
          </Container>
        </>

      ) : (
        <ConsiderSupport supportId={searchParams.get("id")} supportTypeId={searchParams.get("type")} />
      )}
    </>

  );
}